import { AttachFile, Save } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import { MuiFileInput } from 'mui-file-input'
import React, { FunctionComponent, useEffect, useState } from 'react'

import { notError, notSuccess } from '../../../../utils/notification'
import { swalException } from '../../../../utils/swal'
import { apiArticuloImportarImagen } from '../../api/apiArticuloImportarImagen'
import { ArticuloProp } from '../../interfaces'

interface OwnProps {
  id: string
  keepMounted: boolean
  open: boolean
  row: ArticuloProp | null
  onClose: (value?: boolean) => void
}

type Props = OwnProps

const ArticuloImportarImagenDialog: FunctionComponent<Props> = (props) => {
  const { row, onClose, open, ...other } = props
  const [imagen, setImagen] = useState<string | null>(null)
  const [file, setFile] = useState<File | null>(null)
  const [formLoading, setFormLoading] = useState(false)

  const onFileChange = (value: File | null) => {
    if (value) {
      if (value.size > 200000) {
        notError('La imagen no puede ser mayor a 200 kb')
      } else {
        setFile(value)
      }
    }
  }

  const onSubmit = async () => {
    if (file) {
      setFormLoading(true)
      const resp = await apiArticuloImportarImagen(
        1,
        row!.codigoArticulo,
        '57',
        file,
      ).catch((e) => {
        swalException(e)
      })
      if (resp) {
        notSuccess('Imagen importada correctamente')
        setImagen(resp.variants.medium)
      }
      setFormLoading(false)
    } else {
      notError('Seleccione una imagen')
    }
  }

  useEffect(() => {
    if (open) {
      if (row?.imagen) {
        setImagen(row?.imagen?.variants?.medium || null)
      } else {
        setImagen(null)
      }
      setFile(null)
    }
  }, [open])

  if (!row)
    return (
      <Dialog maxWidth="md" disableRestoreFocus open={open} {...other}>
        <DialogContent dividers>Seleccione el articulo</DialogContent>
        <DialogActions>
          <Button color={'error'} disabled={formLoading} onClick={() => onClose(false)}>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    )

  return (
    <Dialog maxWidth="xs" disableRestoreFocus open={open} {...other}>
      <DialogTitle>Importar imagen para el articulo {row.codigoArticulo}</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ textAlign: 'center' }}>
          {imagen ? (
            <img src={imagen} alt={row.nombreArticulo} style={{ maxHeight: 250 }} />
          ) : (
            <p>Imagen no disponible</p>
          )}
        </Box>

        <MuiFileInput
          size="small"
          sx={{ mt: 3 }}
          value={file}
          inputProps={{ accept: '.png, .jpeg, .webp, .jpg' }}
          InputProps={{
            startAdornment: <AttachFile />,
          }}
          placeholder="Seleccionar imagen"
          onChange={onFileChange}
        />
        <small>Imagen soportado .png, .jpeg, .webp, .jpg, no mas de 100 kb</small>
      </DialogContent>
      <DialogActions>
        <Button
          color={'error'}
          disabled={formLoading}
          onClick={() => {
            onClose(!!file)
          }}
        >
          Cerrar
        </Button>
        <LoadingButton
          size={'small'}
          color={'primary'}
          loading={formLoading}
          variant={'contained'}
          sx={{ mr: 2 }}
          startIcon={<Save />}
          onClick={onSubmit}
        >
          Importar Imagen
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export default ArticuloImportarImagenDialog
